import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const DissertationServices: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const otherServices = [
    { title: "Dissertation", route: "/dissertation-writing-services" },
    { title: "Coursework", route: "/coursework-writing" },
    { title: "Project writing services", route: "/project-report-writing" },
    { title: "Publication", route: "/publication-services" },
    { title: "Literature review", route: "/literature-review-writing" },
    { title: "Manuscript", route: "/manuscript-preparation" },
    { title: "Research methodology", route: "/research-methodology-services" },
  ];

  const data = {
    icon: "ds4.webp",
    title: "Data Analytsis",
    image: "ds4.webp",
    description:
      "In assignment writing for data analytics, students analyze and interpret data to uncover insights and trends relevant to their research. This process involves using statistical tools and techniques to evaluate datasets, identify patterns, and draw conclusions that support the assignment's objectives. Clear presentation of the findings, backed by data visualization, ensures that the analysis is easy to understand and contributes to the overall quality and impact of the research.",

    additionalInfo: [
      {
        title: "Qualitative Analysis",
        description:
          "At our company, we specialize in helping students with qualitative analysis in data analytics assignments. We guide them in interpreting non-numerical data, such as interviews and survey responses, to identify meaningful themes and insights. Our approach adds depth and context to the research, helping students understand the behaviors behind the data and supporting their conclusions with richer analysis for a more comprehensive assignment.",

        icon1: "",
        cards: [
          {
            title: "Data Collection Methods",

            description:
              "Choosing the right data collection method is key in qualitative analysis. This topic covers techniques like interviews, focus groups, and surveys, ensuring that the gathered data aligns with the research objectives and provides valuable insights.",
          },
          {
            title: "Thematic Analysis",

            description:
              "Thematic analysis involves identifying and organizing patterns or themes within qualitative data. This topic focuses on how to systematically analyze responses to draw out recurring concepts, which helps to explain key behaviors and trends.",
          },
          {
            title: "Coding Techniques",

            description:
              "Coding is the process of categorizing qualitative data into manageable segments. This topic emphasizes how to code data efficiently, breaking down large amounts of information into clear categories for easier analysis and interpretation.",
          },
          {
            title: "Data Interpretation",

            description:
              "Effective interpretation is crucial in qualitative analysis. This topic discusses how to draw meaningful conclusions from themes and patterns, linking them back to the research question and ensuring the findings are insightful and relevant to the study.",
          },
        ],
      },
      {
        title: "Big Data Analytics",
        description:
          "At our company, we assist students in utilizing big data analytics for their assignments. We help them analyze large and complex datasets using advanced tools and techniques to uncover patterns and insights. This enables students to support their research objectives, solve complex problems, and make data-driven conclusions. With our guidance, students can confidently tackle big data, enhancing the quality and impact of their assignments.",

        icon1: "",
        cards: [
          {
            title: "Data Collection and Storage",

            description:
              "Handling big data starts with collecting and storing massive datasets from various sources. This topic explores the importance of using efficient tools and systems to manage large volumes of information, ensuring data is easily accessible and well-organized for analysis.",
          },
          {
            title: "Data Processing Tools",

            description:
              "Big data requires advanced processing techniques to analyze vast amounts of information. This topic covers tools like Hadoop and Spark, which enable students to process and analyze data quickly, transforming raw data into actionable insights.",
          },
          {
            title: "Pattern Recognition and Trends",

            description:
              "One of the key goals in big data analytics is identifying patterns and trends. This topic emphasizes how to use data mining and machine learning techniques to detect significant relationships within large datasets, helping to answer research questions.",
          },
          {
            title: "Data Visualization",

            description:
              "Effectively presenting insights from big data is crucial. This topic discusses the use of data visualization tools, such as Tableau or Power BI, to create charts and graphs that make complex data more understandable and help convey key findings clearly and efficiently.",
          },
        ],
      },
      {
        title: "Bio-statistics",
        description:
          "At our company, we assist students in applying biostatistics for their data analytics assignments. We help them analyze biological or health-related data using statistical methods to uncover trends, relationships, and outcomes. Our guidance ensures students can make data-driven conclusions, enhancing the accuracy and quality of their health research. With our support, students can confidently apply biostatistics to support evidence-based decisions in their assignments.",

        icon1: "",
        cards: [
          {
            title: "Descriptive Statistics",

            description:
              "Descriptive statistics summarize and describe the main features of a dataset. This topic covers measures such as mean, median, mode, and standard deviation, which help students understand the basic characteristics of their biological or health data, providing a foundation for further analysis.",
          },
          {
            title: "Inferential Statistics",

            description:
              "Inferential statistics enable students to make predictions or generalizations about a population based on a sample. This topic emphasizes hypothesis testing, confidence intervals, and p-values, equipping students with the tools to draw meaningful conclusions from their data.",
          },
          {
            title: "Regression Analysis",

            description:
              "Regression analysis is used to examine relationships between variables. This topic focuses on techniques such as linear and logistic regression, helping students understand how to model and predict outcomes based on their data, which is essential for health research.",
          },
          {
            title: "Statistical Software Applications",

            description:
              "Familiarity with statistical software is crucial for conducting biostatistical analysis. This topic explores tools like R, SAS, or SPSS, enabling students to perform complex calculations and visualizations efficiently, enhancing their data analysis capabilities and improving their assignment outcomes.",
          },
        ],
      },
      {
        title: "Econometries",
        description:
          "At our company, we help students leverage econometrics for their data analytics assignments. Our team guides them in applying statistical methods to economic data to analyze relationships and forecast trends. We emphasize the importance of testing economic theories and evaluating policy impacts, enabling students to make informed, data-driven decisions. With our support, students can derive meaningful insights that enhance the rigor and validity of their economic analyses, elevating the quality of their assignments.",

        icon1: "",
        cards: [
          {
            title: "Basic Econometric Concepts",

            description:
              "Understanding basic econometric concepts, such as regression analysis, correlation, and causation, is essential. This topic introduces students to key terms and principles, providing a solid foundation for analyzing economic data and interpreting results accurately.",
          },
          {
            title: "Model Specification",

            description:
              "Model specification involves selecting the appropriate model to analyze economic relationships. This topic covers how to identify relevant variables and the importance of correctly specifying the model to ensure valid and reliable results in econometric analysis.",
          },
          {
            title: "Estimation Techniques",

            description:
              "Various estimation techniques, such as Ordinary Least Squares (OLS) and Maximum Likelihood Estimation (MLE), are vital for econometric analysis. This topic discusses these methods, explaining how to apply them to estimate parameters and make inferences about economic relationships.",
          },
          {
            title: "Hypothesis Testing",

            description:
              "Hypothesis testing is crucial for validating econometric models. This topic emphasizes the process of formulating null and alternative hypotheses, conducting tests (like t-tests and F-tests), and interpreting p-values to draw conclusions from economic data.",
          },
        ],
      },
      {
        title: "Content analysis",
        description:
          "At our company, we assist students in utilizing content analysis for their data analytics assignments. We guide them in systematically evaluating qualitative data, such as texts, interviews, or media, to identify key patterns and themes. Our approach enables students to quantify and analyze the presence of specific words, phrases, or concepts, providing valuable insights into communication and societal trends. With our support, students can draw meaningful conclusions and strengthen their research findings through evidence-based interpretations, enhancing the overall quality of their assignments.",

        icon1: "",
        cards: [
          {
            title: "Types of Content Analysis",

            description:
              "Understanding the different types of content analysis, such as qualitative, quantitative, and mixed methods, is essential. This topic explores how each approach serves distinct purposes, allowing students to choose the most suitable method for their research objectives.",
          },
          {
            title: "Coding and Categorization",

            description:
              "Coding involves categorizing data into manageable segments for analysis. This topic focuses on developing coding schemes and identifying themes or patterns, enabling students to organize qualitative data systematically and derive meaningful insights.",
          },
          {
            title: "Data Interpretation",

            description:
              "Data interpretation is crucial for drawing conclusions from content analysis. This topic discusses how to analyze coded data, identify trends, and relate findings back to research questions, ensuring that interpretations are clear and relevant to the study.",
          },
          {
            title: "Ethical Considerations",

            description:
              "Ethical considerations in content analysis involve ensuring the integrity and confidentiality of data sources. This topic emphasizes the importance of ethical practices, including proper citation, respectful representation of subjects, and awareness of potential biases in analysis.",
          },
        ],
      },
      {
        title: "Software Programming",
        description:
          "At our company, we assist students in utilizing software programming for their data analytics assignments. We help them learn programming languages like Python and R to manipulate, analyze, and visualize data effectively. By mastering these skills, students can automate tasks and perform complex analyses, leading to more accurate and insightful results in their assignments.",

        icon1: "",
        cards: [
          {
            title: "Programming Languages for Data Analytics",

            description:
              "Understanding various programming languages, such as Python and R, is essential for data analytics. This topic covers the strengths and applications of each language, helping students choose the most suitable tool for their specific analytical needs.",
          },
          {
            title: "Data Manipulation Techniques",

            description:
              "Data manipulation involves cleaning and transforming raw data for analysis. This topic emphasizes techniques like filtering, sorting, and aggregating data, enabling students to prepare their datasets effectively for further exploration and insights.",
          },
          {
            title: "Data Visualization Libraries",

            description:
              "Data visualization is crucial for presenting analytical findings clearly. This topic explores libraries such as Matplotlib and ggplot2, which allow students to create compelling visualizations that enhance the communication of their results and findings.",
          },
          {
            title: "Automation and Scripting",

            description:
              "Automation in programming enables students to streamline repetitive tasks. This topic discusses the importance of scripting in data analytics, allowing students to develop efficient workflows and focus on higher-level analytical thinking while saving time on data processing.",
          },
        ],
      },
    ],
  };
  const handleServiceClick = (route: string) => {
    window.location.href = route;
  };

  const handleHeadingClick = (index: number) => {
    setActiveIndex(activeIndex === index ? 0 : index);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: "#172554",
          padding: { sm: 0, lg: 3 },
          display: "flex",
          flexDirection: "row-reverse",
        }}
        className="component"
      >
        {/* Left Side - Other Services List (Desktop) and Expandable Headings (Mobile) */}
        <Grid item xs={12} md={3}>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <List>
              {data.additionalInfo.map((info, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleHeadingClick(index)}
                  selected={activeIndex === index}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={info.title} />
                </ListItem>
              ))}
              <Typography
                sx={{ textAlign: "center", color: "white", fontWeight: "bold" }}
              >
                Our Other Services
              </Typography>
              {otherServices.map((service, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleServiceClick(service.route)}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={service.title} />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Mobile View - Expandable Headings */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {data.additionalInfo.map((info, index) => (
              <Box key={index}>
                <ListItem
                  button
                  onClick={() => handleHeadingClick(index)}
                  sx={{
                    color: "white",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <ListItemText primary={info.title} />
                  <IconButton sx={{ color: "white" }}>
                    {activeIndex === index ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </ListItem>
                <Collapse
                  in={activeIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "black",
                      padding: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {info.description}
                    </Typography>
                    {info.cards.map((card, cardIndex) => (
                      <Card
                        key={cardIndex}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#172554",
                          color: "white",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6">
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2">
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Side - Dissertation Content (Desktop Only) */}
        <Grid item md={9} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#f3f4f6",
              boxShadow: "none",
              borderRadius: "0px",
            }}
          >
            {activeIndex !== null && (
              <>
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                  {data.additionalInfo[activeIndex].title}
                </Typography>
                <Box sx={{ marginBottom: 2 }}></Box>
                <Typography sx={{ marginBottom: 4, textAlign: "center" }}>
                  {data.additionalInfo[activeIndex].description}
                </Typography>

                <Grid
                  container
                  direction="column"
                  spacing={2}
                  sx={{
                    backgroundColor: "#172554",
                    color: "white",
                    borderRadius: "4px",
                    maxWidth: { lg: "75%", xs: "100%" },
                  }}
                >
                  {data.additionalInfo[activeIndex].cards.map((card, index) => (
                    <Grid item key={index}>
                      <Card
                        sx={{
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "white",
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" color={"white"}>
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2" textAlign={"center"}>
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DissertationServices;
